
<template>
  <div class="notes">

    <!-- Loading Animation START -->
    <div v-if="busy" class="full-box">
      <div class="loadingWorkOrders">
        <div class="logo"></div>
        <div class="loading-image"><i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw mcText"></i></div>
        Loading Notes for Work Order #{{this.$route.params.id}}        
      </div>
    </div>
    <!-- Loading Animation END -->

    <!-- Mobile Menu START -->
    <template v-if="openMenu">
      <div class="overlay">
        <div class="mobile-menu">
          <div class="inner">
            <div v-on:click="hideMenu()" class="close-menu"><i class="fa fa-times" aria-hidden="true"></i></div>
            <h2>{{username}}</h2>
            <ul>
              <li v-on:click="backToListings()">My Work Orders <i class="fa fa-list-ul" aria-hidden="true"></i></li>
              <li v-on:click="logout()">Log Out <i class="fa fa-sign-out" aria-hidden="true"></i></li>
            </ul>
            <br><br>
          </div>
        </div>
      </div> 
    </template>
    <!-- Mobile Menu END -->

    <!-- Main Header START -->
    <div class="main-header">

      <div class="top">
        <div class="container">
          <div class="row">
            <div class="col-xs-12">

            <!-- Tablet Header START -->
            <div v-if="$mq.resize && $mq.above($mv.tablet)">
              <button v-on:click="goBackToWO()" class="pull-right btn header-btn mcBG scBGHover"><i class="fa fa-reply" aria-hidden="true"></i> Back to the Work Order</button>
            </div>
            <!-- Tablet Header END -->

            <!-- Mobile Header START -->
            <div v-if="$mq.resize && $mq.below($mv.tablet - 1)">
              <ul>
                <li v-on:click="goBackToWO()"><i class="fa fa-reply" aria-hidden="true"></i></li>
                <li v-on:click="showMenu()"><i class="fa fa-bars" aria-hidden="true"></i></li>
              </ul>
            </div>
            <!-- Mobile Header END -->
              
            <div class="logo"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- Main Header END -->

    <!-- Header Bar START -->
    <div class="inner-header-bar mcBG">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <img src="static/img/i3v_icon_white.png" class="pull-right">
              <div v-if="$mq.resize && $mq.below($mv.tablet - 1)">
                <h1>Notes <span>[WO# {{workOrder}}]</span> </h1>
              </div>
              <div v-if="$mq.resize && $mq.above($mv.tablet)">
                <h1>Notes - WO# {{workOrder}} </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Header Bar END -->

    <!-- Main Tablet View START 
    [[ Everything starting from now is what's seen in desktop/tablet mode. The exact pixel value is defined in the "main.js" file, at the moment of this comment, it was 768px. If the viewport is less than 768px, which are small tablets and mobile phones, then they cannot see the following. ]] -->
    <div v-if="$mq.resize && $mq.above($mv.tablet)" class="tablet-view">
      <div class="container">

        <div class="row flexrow">

          <!-- Left Column START 
          [[ This is where we show the Notes ]] -->
          <div class="col-sm-5">
            <div class="inner">
              <h2>Internal Notes</h2>
              <div id="woListing">
                <ul> 
                  <li v-for="note in notesRecords.slice().reverse()">
                    <div class="container-fluid"> 
                      <div class="row">
                        <div clworkOrder.priorityass="col-xs-12">
                          <div class="woTopRow">
                            <strong>{{note.sender}}</strong>
                          </div>
                          <div><strong>{{note.messageTimeStamp | moment("MMM Do, YYYY HH:MM") }}:</strong> {{note.Note}}</div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Left Column END --> 

          <!-- Center Column START 
          [[ This is where we show the Reply box ]] -->
          <div class="col-sm-4">
            <div class="inner">
              <div v-if="!workOrderCheck.fieldComplete">

                <h2>Send a Note:</h2>
                <div>
                    <div class="form-group">
                      <textarea class="form-control" v-model="usersNote"></textarea>
                    </div>

                    <div>
                      <div class="form-group">
                        <button v-on:click="submitForm" type="button" class="btn mcBG scBGHover">Reply</button>
                      </div>     
                    </div>
                </div>
              </div> 
            </div>
          </div>
          <!-- Center Column END --> 

          <!-- Right Column START 
          [[ This is where we show the Menu ]] -->
          <div class="col-sm-3">
            <div class="inner-dark">
              <h3 class="mcText"><span>Username</span>
              {{username}}</h3>
              <ul>
                <li v-on:click="refreshListing()">My Work Orders <i class="fa fa-list-ul" aria-hidden="true"></i></li>
                <li v-on:click="logout()">Log Out <i class="fa fa-sign-out" aria-hidden="true"></i></li>
              </ul><br><br>
            </div>
          </div>
          <!-- Right Column END -->

        </div>
      </div>
    </div> 
    <!-- Main Tablet View END -->

    <!-- Main Mobile View START 
    [[ Everything starting from now is what's seen in mobile mode. The exact pixel value is defined in the "main.js" file, at the moment of this comment, it was 768px. If the viewport is more than 768px, which are small tablets and mobile phones, then they cannot see the following. ]] -->
    <div v-if="$mq.resize && $mq.below($mv.tablet - 1)">
      <div class="mobile-view">
        <div id="woListing">
          <ul> 
            <!-- Notes START   -->
            <li v-for="note in notesRecords.slice().reverse()">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-xs-12">
                    <div class="woTopRow">
                      {{note.sender}}
                    </div>
                    <div><strong>{{note.messageTimeStamp | moment("MMM Do, YYYY HH:MM") }}:</strong> {{note.Note}}</div>
                  </div>
                </div>
              </div>
            </li>
            <!-- Notes END --> 
          </ul>
        </div>

        <div v-if="!workOrderCheck.fieldComplete">
          <div>
            <div class="mobileBottomBar">
                
              <div class="form-group">
                <textarea class="form-control" v-model="usersNote"></textarea>
              </div>

              <div>
                <div class="form-group">
                  <button v-on:click="submitForm" type="button" class="btn mcBG scBGHover">Reply</button>
                </div>     
              </div>

            </div>
          </div>
        </div> 

      </div>
    </div>
    <!-- Main Mobile View END --> 

    <!-- Debug DATA START -->
    <pre v-show="false">
      {{ $data }}
    </pre>
    <!-- Debug DATA END -->
    
  </div> <!-- </material> -->
</template>

<script>
import User from '../services/user'
import { getNotes, getWorkOrder, postNotesRecord } from '../services/requests'

export default {
  name: 'notes',

  created() {

    // Loading Message True
    this.busy = true

    // Initial WO number
    this.workOrder = this.$route.params.id

    // Username to display on Mobile Menu/Third Column
    this.username = User.getUsername()

    // Grab WO information (for checking if WO is closed or not)
    getWorkOrder(this.$route.params.id)
      .toArray((workOrders) => {
        this.workOrderCheck = workOrders[0]
      }
    )

     getNotes(this.workOrder)
      .toArray((notesRecords) => {
        this.notesRecords = notesRecords
        this.busy = false
      })

  },
  methods: {

submitForm() {

    // Show saving Animatino
    this.busySaving = true;

    let record = {
      uRecId: '',   
      systemCode: User.getSystemCode(),
      woNumber: this.workOrder,
      sender: User.getUsername(),
      Note: this.usersNote
    }


    postNotesRecord(this.workOrder, record)
        .stopOnError((err) => {
          
          var errorArray = JSON.parse(err.message)
          this.errorArray = errorArray
          alert('Error: ' + this.errorArray.body.uMMds.uMMErrorLog[0].errorMsg)
          
          this.busySaving = false;
        })
        .done(() => {

          this.usersNote = "";

          getNotes(this.workOrder)
          .toArray((notesRecords) => {
            this.notesRecords = notesRecords;

            this.busySaving = false;
          })
              
          reload();
           
        })

},

     backToListings() {
      this.$router.push('/')
    },

    // Menu link to get back to the WO
    goBackToWO() {
      this.$router.replace('/workorder/' + this.workOrder)
    }, 

    // Reload notes
    reload() {
      this.$router.replace('/workorder/notes' + this.workOrder)
    }, 

    // Main Method to Log Out
    logout() {
      User.logout()
      this.$router.replace('/login')
      alert('You have succesfully logged out!')
    },

    // Show/Hide Mobile Menus
    showMenu() {
      this.openMenu = true;
    },
    hideMenu() {
      this.openMenu = false;
    },

  },
  components: {
  },
  data () {
    return {
      notesRecords: [],
      busySaving: false,
      busyUploading: false,
      usersNote: '',
      record: [],
      workOrderCheck: [],
      openMenu: false,
      busy: true,
      buttonTitle: 'Save',
      editing: false,
      params: [],
      busySave: false,
      busyEdit: false,
      editingRow: '',
      workOrder: ''
    }
  }
}
</script>

<style scoped>
.notes {
 padding-top: 102px;
  position: relative;
}

.mobileBottomBar {
  display: none;
}

  .notes .main-header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2;
    padding: 0;
  }

.notes .main-header .top {
  background: #fff;
  padding-top: 10px;
  padding-bottom: 10px;
  }

  .notes .header-btn {
    color: #fff;
    font-family: 'open_sanssemibold';
    font-size: 12px;
    margin-left: 10px;
  }

    .notes .header-btn i {
      margin-right: 5px;
    }

    .tablet-view {
      padding-top: 30px;
      padding-bottom: 30px;
    }

    .tablet-view .form-group {
      padding: 0 20px;
      margin: 15px 0;
    }

    .tablet-view .form-group .form-control {
      background: #eef2f4;
      font-size: 13px;
      color: #666;
    }

     .tablet-view .datepicker input {
        background-color: #fff;
        background-image: none;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset;
        color: #555;
        display: block;
        font-size: 14px;
        height: 34px;
        line-height: 1.42857;
        padding: 6px 12px;
        transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
        width: 100% !important;
        background: #eef2f4;
        font-size: 13px;
        color: #666;
     }

    .tablet-view .form-group .btn {
      color: #fff;
      border: 0;
      font-family: 'open_sansbold';
        font-size: 14px;
        text-transform: uppercase;
        font-weight: normal;
        padding: 5px 15px;
        margin: 0 auto;
        display: block;
    }

    .tablet-view .form-group strong span {
      cursor: pointer;
    }

.innerWOListing,
.innerWOListing li {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.innerWOListing li {
  padding: 12px;
  color: #010101;
}

.innerWOListing li:nth-of-type(even) {
  background: #f9f9f9;
}



.innerWOListing .del-btn {
  color: #fff;
  padding: 2px 6px;
  font-size: 12px;
}

.innerWOListing li strong {
  display: inline-block;
  font-family: 'open_sansbold';
  font-weight: normal;
  text-transform: uppercase;
}

.innerWOActions,
.innerWOActions li {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

  .innerWOActions {
    margin-bottom: 40px;
    }

  .innerWOActions li {
    padding: 15px 10px 15px 20px;
    font-size: 18px;
    color: #010101;
    cursor: pointer;
  }

  .innerWOActions li i {
    color: #666;
    margin-right: 10px;
  }

  .innerWOActions li:nth-of-type(even) {
    background: #f3fbff;
  }

.innerWOListing li .actions {
  float: right;
  font-size: 21px;
}

.innerWOListing li.mcBGactive {
    display: block;      
    color: #fff !important;
  }     

.innerWOListing li.mcBGactive i {
    color: #fff !important;
  }

@media only screen and (max-width : 768px) {

.notes input[type="file"] {
  text-align: center;
  margin: 0 auto;
}

  .innerWOtopRow {
    text-align: center;
  }

  .innerWOtopRow .row {
    display: flex;
    font-size: 17px;
  font-family: 'open_sanssemibold';
  }

  .innerWOtopRow .left {
    background: #e7e7e7;
    border-bottom: #d4d1d1 solid 4px;
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .innerWOtopRow .right {
    padding-top: 30px;
    padding-bottom: 30px;
  } 

  .innerWOtopRow h5 {
  font-size: 11px;
  color: #999;
  text-transform: uppercase;
  margin: 0;
  padding: 0 0 5px 0;
  }

  .innerWOtopRow .right h5 {
    color: #e9e9e9;
    }

   .innerWOmainListing {
     margin: 20px 0px;
     text-align: center;
     font-size: 14px;
   } 

   .innerWOmainListing p {
    margin: 0 0 3px;
    padding: 0 5px;
   }

   .innerWOmainListing strong {
   font-weight: normal;
   font-family: 'open_sanssemibold';
   }

   .innerWOmainListing p.priorityHigh {
    background: #cc0000;
      color: #fff;
      font-family: 'open_sanssemibold';
      padding: 5px;
   }

   .innerWOmainListing p.priorityMedium {
      background: #ff9900;
      color: #fff;
      font-family: 'open_sanssemibold';
      padding: 5px;
   }

   .innerWOmainListing p.priorityScheduled {
      background: #66cc00;
      color: #fff;
      font-family: 'open_sanssemibold';
      padding: 5px;
   }

   .innerWoCompletion {
    background: #f8f8f8;
    padding: 25px;
   }


    .innerWoCompletion .form-group .form-control {
      background: #eef2f4;
      font-size: 13px;
      color: #666;
    }

    .innerWoCompletion .form-group .btn {
      color: #fff;
      font-family: 'open_sansbold';
        font-size: 14px;
        text-transform: uppercase;
        font-weight: normal;
        padding: 5px 15px;
        margin: 0 auto;
        display: block;
    }
  
}









.loadingWorkOrders {
  text-align: center;
  font-size: 17px;
  font-family: 'open_sanssemibold';
  padding-top: 20px;
}

  .loadingWorkOrders img {
    display: block;
    margin: 0 auto 10px;
  }


  #woListing {
    width: 100%;
  }

  #woListing ul,
  #woListing ul li {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: block;
  width: 100%;
  }

    #woListing ul li {
      padding: 10px 0 10px 50px;
      background-repeat: no-repeat;
      background-position: 15px center;    
      cursor: pointer;
    }

    #woListing ul li.priorityHigh {
      border-left: 8px solid #cc0000;
    }

    #woListing ul li.priorityScheduled {
      border-left: 8px solid #66cc00;
    }

    #woListing ul li.priorityMedium {
      border-left: 8px solid #ff9900;
    }

    #woListing ul li .woTopRow {
      font-size: 16px;
    }

    #woListing ul li:nth-child(odd) {
      background-color: #eaeaea;
    }

     #woListing ul li strong {
     font-weight: normal;
     font-family: 'open_sansbold';
     }

      #woListing ul li img {
        padding-top: 30px;
      }

.tablet-view {
  background: #f5f8fb;
}

.flexrow {
  display: flex;
}

  .tablet-view .tabletSortSearchRow {
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 12px; 
    font-family: 'open_sanssemibold';
  }

    .tablet-view .tabletSortSearchRow a {
      display: inline-block;
      margin: 0 0 5px;
      padding: 3px 10px;
      text-decoration: none;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
    }

    .tablet-view .tabletSortSearchRow a.active {
      color: #fff;
    }

    .tablet-view .tabletSortSearchRow .form-control {
      max-width: 70%;
      display: inline-block;
      margin-left: 10px;
      height: 26px;
      font-size: 12px;
      background-color: #e7edf2;
      border: 0;
    }

    .tablet-view .tabletSortSearchRow .btn {
      max-width: 10%;
      color: #fff;
    }

    .tablet-view .inner {
       background: #fff;
       min-height: 100%;
    }

    .tablet-view .inner-dark {
      background: #212121;
      color: #fff;
      padding: 5px;
      text-align: center;
      min-height: 100%;
    }

      .tablet-view .inner-dark h3 {
        border-top: #555 solid 2px;
        border-bottom: #555 solid 2px;
        padding: 10px 0;
        margin: 0;
        font-size: 16px;
        color: #00b7e3;
         font-family: 'open_sanssemibold';
      }

      .tablet-view .inner-dark h3 span {
        font-size: 11px;
        text-transform: uppercase;
        color: #777;
        display: block;
        margin-bottom: 5px;
      }

      .tablet-view .inner-dark ul,
      .tablet-view .inner-dark ul li {
        margin: 0;
        padding: 0;
        list-style-type: none;
        text-align: right;
      }

       .tablet-view .inner-dark ul {
        padding-right: 20px;
        padding-top: 10px;
       }

        .tablet-view .inner-dark ul li {
          color: #fff;
          padding: 10px 0;
          cursor: pointer;
        }

        .tablet-view .inner-dark ul li i {
          margin-left: 5px;
          color: #999;
        }

    .tablet-view h2 {
      margin: 0;
      padding: 20px;
      font-size: 20px;
      border-bottom: 1px solid #ccc;
      font-family: "ralewayblack";
      text-transform: uppercase;
    }

    .tablet-view .completedtrue {
      border: 0 !important;
      background-image: none !important;
      padding: 10px 0 10px 10px !important;
    }

    .tablet-view .completedtrue:nth-child(odd) {
      background-color: #f3fbff !important;
    }

.mobile-view .completedtrue {
  background: #333 !important;
  color: #ccc;
  border-bottom: 1px dotted #666;
}
    .mobile-view .completedtrue .woTopRow {
      color: #fff;
    }


@media only screen and (max-width : 768px) {
  #woListing {
    height: 130%;
    overflow: scroll;
    overflow-x: hidden;
  }

  #woListing ul li img {
    padding-top: 40px;
  }

    #woListing ul li {
      font-size: 11px;
      background-position: 10px center;
      padding: 15px 0 15px 10px;
    }

    #woListing ul li .woTopRow {
      font-size: 15px;
    }

    #woListing ul li.completedtrue {
      background-image: url(../../static/img/icon-wo-closed.png) !important;
      background-color: #333 !important;
      background-repeat: no-repeat !important;
      background-position: 10px center !important;
      border-left: 8px solid #006600 !important;
    }

    #woListing ul li.priorityHigh {
      border-left: 8px solid #cc0000 !important;
    }

    #woListing ul li.priorityScheduled {
      border-left: 8px solid #66cc00 !important;
    }

    #woListing ul li.priorityMedium {
      border-left: 8px solid #ff9900 !important;
    }

  .mobileBottomBar {
    background: #fff center center repeat-y;
    height: 120px;
    position: fixed;
    bottom: 00px;
    display: block;
    z-index: 2;
    width: 100%;
    text-align: center;
    cursor: pointer;
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
     -webkit-box-shadow: 0px -3px 5px #666;
    -moz-box-shadow:    0px -3px 5px #666;
    box-shadow:         0px -3px 5px #666;
    font-family: 'open_sanssemibold';
    font-size: 15px;
    color: #fff;
  }

  .mobileBottomBar span {
    display: block;
    font-size: 12px;
  }

  .mobileBottomBar .searchDiv {
    padding-top: 10px;
  }

  .mobileBottomBar .searchDiv i {
    font-size: 17px;
    margin-right: 5px;
  }

  /* .mobileBottomBar {
    background: #fff;
    position: fixed;
    bottom: 0px;
    display: block;
    z-index: 2;
    width: 100%;
    text-align: center;
    cursor: pointer;
    padding-top: 00px;
     -webkit-box-shadow: 0px -3px 5px #666;
    -moz-box-shadow:    0px -3px 5px #666;
    box-shadow:         0px -3px 5px #666;
    font-family: 'open_sanssemibold';
    font-size: 15px;
    color: #999;
  }

  .mobileBottomBar .col-xs-4 {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .mobileBottomBar .center {
    border-left: 2px solid #ddd;
    border-right: 2px solid #ddd;
  }

  .mobileBottomBar span {
    display: block;
    font-size: 12px;
  } */

  .mobile-sort {
    background: #fff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    max-width: 75%;
    min-width: 50%;
    position: absolute;
    left: 50%;
    top: 50px;
    transform: translateX(-50%);
    padding: 10px;
    text-align: center;
  }

    .mobile-sort h3 {
      font-family: 'open_sansbold';
      text-transform: uppercase;
      margin: 15px 0 15px 0;
      padding: 0;
      color: #000;
    }

    .mobile-sort p {
      display: block;
      margin: 0;
      padding: 10px 0;
      border-bottom: 1px solid #ddd;
    }

    .mobile-sort p:last-of-type {
      border-bottom: 0px;
    }

    .mobile-sort p a {
    display: block;
    color: #333;
    text-decoration: none;
    font-family: 'open_sanssemibold';
    }

    .mobile-sort p a.active {
      font-family: 'open_sansbold';
      text-transform: uppercase;
    }

  .mobile-search {
    background: #fff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    width: 90%;
    position: absolute;
    left: 50%;
    top: 50px;
    transform: translateX(-50%);
    padding: 10px;
    text-align: center;
    font-family: 'open_sansbold';
  }

    .mobile-search h3 {
      font-family: 'open_sansbold';
      text-transform: uppercase;
      margin: 15px 0 15px 0;
      padding: 0;
      color: #000;
    }

    .mobile-search input {
    margin-bottom: 20px;
    text-align: center;
    }

    .mobile-search a.btn {
      font-family: 'open_sansbold' !important;
      font-size: 16px;
      color: #fff;
      text-transform: uppercase;
    }

}

body {
min-height: 100%;
min-width: 100%;
}

.full-box {
  min-height: 100%;
  min-width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 5;
}

  .full-box .loadingWorkOrders {
    margin-top: 100px;
  }

  .full-box .main-logo {
    max-width: 150px;
  }

  .form-control.small{
 width: 60px;
 display: inline-block;
 text-align: center;
}

.innerWOListing li .top-row {
  font-size: 13px;
 text-transform: uppercase;
}

.innerWOListing li {
  font-size: 12px;
}

.innerWOListing li .actions {
  float: right;
  font-size: 21px;
}

.innerWOListing li .actions div {
  display: inline-block;
}

.innerWOListing li .actions i {
  margin: 0 0 0 10px;
}

.innerWOListing li .actions i:hover {
  cursor: pointer;
}

.statusMSG {
  text-align: center;
  font-size: 15px;
}

.edit-box {
  background: #fff;
  -webkit-border-radius: 10px;
-moz-border-radius: 10px;
border-radius: 10px;
max-width: 500px;
margin: 30px auto 0;
padding-bottom: 20px;
}

.lem-formTop {
  background: #f8f8f8;
  padding: 15px;
  text-align: center;
}

.lem-formTop input,
.lem-formTop select {
  text-align: center;
}

.lem-formTop .form-control.small{
 width: 30px;
 display: inline-block;
 text-align: center;
 padding: 6px 0;
}

 .lem-formTop h2 {
      margin: 0;
      padding: 10px 0;
      font-size: 20px;
      font-family: "ralewayblack";
      text-transform: uppercase;
    }

    .lem-formTop .btn {
      border: 0;
      color: #fff;
      font-family: 'open_sansbold';
        font-size: 14px;
        text-transform: uppercase;
        font-weight: normal;
        padding: 5px 15px;
         margin-top: 25px;
        display: block;
        width: 100%;
    }

.lem-dividingCount {
  padding: 5px 0;
  text-align: center;
  font-family: 'open_sanssemibold';
  color: #fff;
  background: #333;
  text-transform: uppercase;
}

.el-select, .el-input {
    width: 100%;
    font-size: 12px;
  }

.el-input-number--small {
  width: 100%;
}


</style>


// WEBPACK FOOTER //
// Notes.vue?0be83bee